module.exports = __webpack_public_path__ + "static/media/medical_captioning.e0220045.png";